import axios from "axios";
import {BLOG_IMAGE_UPLOAD_URL, config} from "../constants";
import authHeader from "./auth-header";

class BlogService {

    save(blogRequest) {
        return axios.post(
            config.API_URL + "blog",
            blogRequest,
            {headers: authHeader()}
        );
    }

    delete(blogRequest) {
        return axios.post(
            config.API_URL + "blog-delete",
            blogRequest,
            {headers: authHeader()}
        );
    }

    blogById(blogRequest) {
        return axios.post(
            config.API_URL + "blog-by-id",
            blogRequest,
            {headers: authHeader()}
        );
    }

    blogByUrl(blogRequest) {
        return axios.post(
            config.API_URL + "blog-by-url",
            blogRequest,
            {headers: authHeader()}
        );
    }

    blogs() {
        return axios.get(config.API_URL + "blogs", {headers: authHeader()})
    }

    saveBlogImage(blogId, data) {
        return axios.post(
            BLOG_IMAGE_UPLOAD_URL + blogId,
            data,
            {headers: authHeader()}
        );
    }

    deleteBlogImage(blogId, fileId) {
        return axios.delete(config.API_URL + "blog-image/" + blogId + "/" + fileId, {headers: authHeader()})
    }

    blogImages(blogId) {
        return axios.get(config.API_URL + "blog-images/" + blogId, {headers: authHeader()})
    }

}

export default new BlogService();
